import { Component, EventEmitter, Input, Output } from '@angular/core';
import { WorkflowContextService } from 'src/app/services';

@Component({
  selector: 'app-workflow-janus-pending-actions',
  templateUrl: './workflow-janus-pending-actions.component.html',
  styleUrls: ['./workflow-janus-pending-actions.component.scss'],
  standalone: false
})
export class WorkflowJanusPendingActionsComponent {

  @Input() row!: any;
  @Input() context: WorkflowContextService;
  @Output() action = new EventEmitter<{ action: string; row: any }>();

  emit(action: string): void {
    this.action.emit({ action, row: this.row });
  }
}
